import { ConsultantSearchCardDataFragment } from "@bonliva-crm/graphql";
import { makeStyles, Typography } from "@material-ui/core";
import { CustomCellRendererProps } from "ag-grid-react";
import locale from "@bonliva-crm/locale";
import { WithCopyToClipboard } from "@common";

export const PhoneRenderer = (
  props: CustomCellRendererProps<ConsultantSearchCardDataFragment>
) => {
  const classes = useStyles();

  if (!props.data?.CellPhone && !props.data?.Phone) {
    return null;
  }

  return (
    <div className={classes.root}>
      {props.data?.CellPhone && (
        <WithCopyToClipboard contentToCopy={props.data.CellPhone}>
          <span>
            <Typography variant="body2" component="span">
              {locale.Mobile}
              {": "}
            </Typography>
            <a
              href={`tel:${props.data.CellPhone}`}
              className={classes.link}
              onClick={(e) => e.stopPropagation()}
            >
              {props.data.CellPhone}
            </a>
          </span>
        </WithCopyToClipboard>
      )}
      {props.data?.Phone && (
        <WithCopyToClipboard contentToCopy={props.data.Phone}>
          <span>
            <Typography variant="body2" component="span">
              {locale.Phone}
              {": "}
            </Typography>
            <a
              href={`tel:${props.data.Phone}`}
              className={classes.link}
              onClick={(e) => e.stopPropagation()}
            >
              {props.data.Phone}
            </a>
          </span>
        </WithCopyToClipboard>
      )}
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column"
  },
  link: {
    color: theme.palette.primary.main
  }
}));
